import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { AuthorizationService } from '../shared/services';

@Directive({
    selector: '[permissions]',
    standalone: false
})
export class PermissionDirective implements OnInit {
  @Input() permissions: any[];
  private actions: any;

  constructor(private el: ElementRef, private authorize: AuthorizationService) {
    this.actions = {
      visible: (action, entity?) => this.visible(action, entity),
      disable: (action, entity?) => this.disable(action, entity)
    };
  }

  ngOnInit() {
    this.permissions.forEach((permission: any[]) => {
      if (this.actions[permission[0]]) {
        this.actions[permission[0]](permission[1], permission[2]);
      }
    });
  }

  private visible(action, entity?) {
    if (!this.isAuthorize(action, entity)) {
      this.el.nativeElement.style.display = 'none';
    }
  }

  private disable(action, entity?) {
    if (!this.isAuthorize(action, entity)) {
      this.el.nativeElement.disabled = true;
    }
  }

  private isAuthorize(action, entity?): boolean {
    return this.authorize.isAuthorize(action, entity);
  }
}
